import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e69043c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增文章")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("分类")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("类型")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("其他选项")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "是否推荐：", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "是否审核通过：", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_14 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"min-width":"50px"} }, "搜索：", -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("推荐")
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("审核")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("设置表单")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_tree_select = _resolveComponent("a-tree-select")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_checkable_tag = _resolveComponent("a-checkable-tag")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_ImageView = _resolveComponent("ImageView")!
  const _component_check_outlined = _resolveComponent("check-outlined")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, {
      title: "资讯列表",
      style: {"margin-bottom":"16px"},
      bordered: ""
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.goSet
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_row, { align: "middle" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { class: "search_label" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_tree_select, {
                  value: _ctx.searches.c_id,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.c_id) = $event)),
                  style: {"width":"250px"},
                  "dropdown-style": { maxHeight: '400px', overflow: 'auto' },
                  placeholder: "请选择",
                  "allow-clear": "",
                  "tree-default-expand-all": "",
                  "tree-data": _ctx.category,
                  "field-names": {
             children: 'children',
             label: 'name',
             key: 'id',
             value: 'id',
           },
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSearch('c_id', $event, '')))
                }, null, 8, ["value", "tree-data"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_divider, { style: {"margin":"12px 0"} }),
        _createVNode(_component_a_row, { align: "middle" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { class: "search_label" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_checkable_tag, {
                  checked: _ctx.searches.type === '',
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSearch('type', '', $event)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["checked"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articleTypes, (item) => {
                  return (_openBlock(), _createBlock(_component_a_checkable_tag, {
                    checked: _ctx.searches.type === item.id,
                    key: item.id,
                    onChange: ($event: any) => (_ctx.onSearch('type', item.id, $event))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["checked", "onChange"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_divider, { style: {"margin":"12px 0"} }),
        _createVNode(_component_a_row, { align: "middle" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { class: "search_label" }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, null, {
              default: _withCtx(() => [
                _hoisted_6,
                _createVNode(_component_a_select, {
                  value: _ctx.searches.is_recommend,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searches.is_recommend) = $event)),
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSearch('is_recommend', $event, $event))),
                  style: {"width":"100px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "" }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "1" }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "0" }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_divider, { type: "vertical" }),
            _createVNode(_component_a_col, null, {
              default: _withCtx(() => [
                _hoisted_10,
                _createVNode(_component_a_select, {
                  value: _ctx.searches.is_show,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searches.is_show) = $event)),
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onSearch('is_show', $event, $event))),
                  style: {"width":"100px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "" }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "1" }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "0" }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_divider, { type: "vertical" }),
            _createVNode(_component_a_col, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_a_input_search, {
                    value: _ctx.searches.keywords,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searches.keywords) = $event)),
                    "enter-button": "",
                    onSearch: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onSearch('keywords', $event, $event))),
                    placeholder: "输入标题搜索"
                  }, null, 8, ["value"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { style: {"flex":"1"} }),
            _createVNode(_component_a_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "dashed",
                  onClick: _ctx.resetSearch
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      dataSource: _ctx.list,
      columns: _ctx.columns,
      loading: _ctx.loading,
      bordered: "",
      pagination: _ctx.pagination,
      onChange: _ctx.handleTableChange
    }, {
      bodyCell: _withCtx(({ column, text, record }) => [
        (column.key === 'title')
          ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 0 }, {
              title: _withCtx(() => [
                _createTextVNode(_toDisplayString(text), 1)
              ]),
              default: _withCtx(() => [
                (record.is_recommend === 1)
                  ? (_openBlock(), _createBlock(_component_a_tag, {
                      key: 0,
                      color: "orange",
                      style: {"margin":"0"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(text.length > 25 ? text.substr(0, 25) + '...' : text), 1)
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true),
        (column.key === 'image')
          ? (_openBlock(), _createBlock(_component_ImageView, {
              key: 1,
              "image-url": text
            }, null, 8, ["image-url"]))
          : _createCommentVNode("", true),
        (column.key === 'type')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(_toDisplayString(text === 1 ? '视频' : text === 2 ? '音频' : '文章'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'if_project')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createTextVNode(_toDisplayString(text === 1 ? '是' : '否'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'category')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _createTextVNode(_toDisplayString(text?.catname || ''), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'is_show')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
              _createTextVNode(_toDisplayString(record.is_show === 1 ? '通过' : ''), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'location_province')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
              _createTextVNode(_toDisplayString(record.location_province) + _toDisplayString(record.location_city), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'sort')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
              (_ctx.editItem?.id === record.id)
                ? (_openBlock(), _createBlock(_component_a_input_search, {
                    key: 0,
                    defaultValue: text,
                    onSearch: _ctx.onSort
                  }, {
                    enterButton: _withCtx(() => [
                      _createVNode(_component_a_button, null, {
                        icon: _withCtx(() => [
                          _createVNode(_component_check_outlined)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["defaultValue", "onSearch"]))
                : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(text), 1))
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'action')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
              _createVNode(_component_a_button, {
                size: "small",
                onClick: ($event: any) => (_ctx.goDetail(record)),
                style: {"margin":"5px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_a_button, {
                size: "small",
                onClick: ($event: any) => (_ctx.goSet(record)),
                style: {"margin":"5px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_a_popconfirm, {
                title: "是否删除该文章?",
                onConfirm: ($event: any) => (_ctx.onDel(record))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    size: "small",
                    style: {"margin":"5px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["onConfirm"]),
              _createVNode(_component_a_popconfirm, {
                title: "审核文章?",
                cancelText: "审核不通过",
                okText: "审核通过",
                onConfirm: ($event: any) => (_ctx.onAudit(record, 1)),
                onCancel: ($event: any) => (_ctx.onAudit(record, 0))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    size: "small",
                    danger: record.is_show === 0,
                    style: {"margin":"5px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_22
                    ]),
                    _: 2
                  }, 1032, ["danger"])
                ]),
                _: 2
              }, 1032, ["onConfirm", "onCancel"]),
              _createVNode(_component_a_button, {
                size: "small",
                onClick: ($event: any) => (_ctx.onRecommend(record)),
                danger: record.is_recommend === 1,
                style: {"margin":"5px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(record.is_recommend === 1 ? '取消推荐' : '设置推荐'), 1)
                ]),
                _: 2
              }, 1032, ["onClick", "danger"]),
              _createVNode(_component_a_button, {
                size: "small",
                onClick: ($event: any) => (_ctx.setSortEditItem(record)),
                style: {"margin":"5px"},
                danger: _ctx.editItem?.id === record.id
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.editItem?.id === record.id ? '取消' : '排序'), 1)
                ]),
                _: 2
              }, 1032, ["onClick", "danger"]),
              _createVNode(_component_a_button, {
                size: "small",
                onClick: ($event: any) => (_ctx.setForm(record)),
                style: {"margin":"5px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_23
                ]),
                _: 2
              }, 1032, ["onClick"])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "columns", "loading", "pagination", "onChange"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.articleVisable,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.articleVisable) = $event)),
      title: "设置表单",
      onOk: _ctx.handleOkForm
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "formRef",
          name: "basic",
          "label-col": { span: 4 },
          "wrapper-col": { span: 20 },
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "选项",
              name: "option_ids"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: _ctx.option_ids,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.option_ids) = $event)),
                  style: {"width":"100%"},
                  placeholder: "请选择选项",
                  mode: "multiple"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.xuanxiangList, (item, index) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: index,
                        value: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "模板",
              name: "template_id"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: _ctx.template_id,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.template_id) = $event)),
                  style: {"width":"100%"},
                  placeholder: "请选择模板"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templateList, (item, index) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: index,
                        value: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }, 8, ["visible", "onOk"])
  ], 64))
}